/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Versions of the device agent's binaries and the platform they run on.
 */
export type AgentStateVersions = {
  /**
   * CPU architecture (Go GOARCH), e.g. arm64.
   */
  arch?: string | undefined;
  /**
   * Operating system (Go GOOS), e.g. darwin.
   */
  os?: string | undefined;
  /**
   * Version of the speakeasy CLI, when the agent could read it.
   */
  speakeasy?: string | undefined;
  /**
   * Version of the menu bar app, when the agent could read it.
   */
  speakeasyUi?: string | undefined;
  /**
   * Version of the speakeasyd daemon.
   */
  speakeasyd: string;
};

/** @internal */
export type AgentStateVersions$Outbound = {
  arch?: string | undefined;
  os?: string | undefined;
  speakeasy?: string | undefined;
  speakeasy_ui?: string | undefined;
  speakeasyd: string;
};

/** @internal */
export const AgentStateVersions$outboundSchema: z.ZodMiniType<
  AgentStateVersions$Outbound,
  AgentStateVersions
> = z.pipe(
  z.object({
    arch: z.optional(z.string()),
    os: z.optional(z.string()),
    speakeasy: z.optional(z.string()),
    speakeasyUi: z.optional(z.string()),
    speakeasyd: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      speakeasyUi: "speakeasy_ui",
    });
  }),
);

export function agentStateVersionsToJSON(
  agentStateVersions: AgentStateVersions,
): string {
  return JSON.stringify(
    AgentStateVersions$outboundSchema.parse(agentStateVersions),
  );
}
